module.exports = require('./helpers/bundle-url').getBundleURL('8ZfPx') + "logo-dark.eefe0b7f.svg";